import _ from 'lodash';
import { fetchVarsFromDb, putNewVarAssociations, conferAndFetchVAR, removeVAR } from './api';

function updateWhere(lst, findBy, updates) {
  const ix = _.findIndex(lst, findBy);
  if (ix < 0) throw new Error('Could not find');
  return [
    ...lst.slice(0, ix),
    { ...lst[ix], ...updates },
    ...lst.slice(ix + 1, lst.length),
  ];
}

const initialState = {
  status: 'unfetched',
  data: null,
  error: null,
};

const mutations = {
  FETCHING(state) {
    state.status = 'loading';
  },
  FETCH_SUCCESS(state, data) {
    state.status = 'fetched';
    state.data = data;
  },
  FETCH_FAILURE(state, msg) {
    state.status = 'failed';
    state.error = msg;
  },
  UPDATING(state, userId) {
    state.data = updateWhere(
      state.data,
      { user_id: userId },
      { loading: true, error: null },
    );
  },
  UPDATED(state, { userId, orgs }) {
    state.data = updateWhere(
      state.data,
      { user_id: userId },
      { loading: false, org_ids: orgs },
    );
  },
  UPDATE_FAILURE(state, { userId, error }) {
    state.data = updateWhere(
      state.data,
      { user_id: userId },
      { loading: false, error },
    );
  },
  INSERTING(state, payload) {
    state.data = [
      ...state.data,
      payload,
    ];
  },
  REMOVING(state, userId) {
    state.data = updateWhere(
      state.data,
      { user_id: userId },
      { loading: true },
    );
  },
  REMOVED(state, userId) {
    state.data = _.reject(state.data, { user_id: userId });
  },
  REMOVE_FAILURE(state, { userId, error }) {
    state.data = updateWhere(
      state.data,
      { user_id: userId },
      { loading: false, error },
    );
  },
};


const actions = {
  async fetch({ commit }) {
    commit('FETCHING');
    try {
      const vars = await fetchVarsFromDb();
      commit('FETCH_SUCCESS', vars);
    } catch (e) {
      commit('FETCH_FAILURE', e);
    }
  },
  async updateVarAssociatedOrgs({ commit }, { orgs, userId }) {
    commit('UPDATING', userId);
    try {
      await putNewVarAssociations({ orgs, userId });
      commit('UPDATED', { userId, orgs: _.map(orgs, 'id') });
    } catch (e) {
      commit('UPDATE_FAILURE', { userId, error: e });
    }
  },
  async addNewVAR({ state, commit }, { id: userId, first_name, last_name }) {
    if (_.find(state.data, { user_id: userId })) {
      return;
    }
    commit('INSERTING', { user_id: userId, first_name, last_name, org_ids: [] });
    try {
      const { org_ids } = await conferAndFetchVAR(userId);
      commit('UPDATED', { userId, orgs: org_ids });
    } catch (e) {
      commit('UPDATE_FAILURE', { userId, error: e });
    }
  },
  async removeVAR({ commit }, userId) {
    commit('REMOVING', userId);
    try {
      await removeVAR(userId);
      commit('REMOVED', userId);
    } catch (e) {
      commit('REMOVE_FAILURE', { userId, error: e });
    }
  },
};

const getters = {
  fetchPayload(state, gtters, rootState, rootGetters) {
    if (!rootGetters.loggedIn) return null;
    return {
      loggedIn: true,
    };
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
  hagridResources: {
    fetch: 'fetchPayload',
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/VARs.js